module.exports = __webpack_public_path__ + "static/media/flamingo.ad07858e.svg";